import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerCodes } from '@shared/modules/logger/logger';
import { WindowRef } from '@shared/services/window-ref/window-ref.service';
import { External, Go, LogError, OrgTriageContinue } from '@store/actions';
import { catchError, map, Observable, of, switchMap, take } from 'rxjs';

import { getConfigClientFromRTE } from '../../../config/config-client';

@Injectable()
export class OrgEffects {
  constructor(
    private actions$: Actions,
    private httpClient: HttpClient,
    private windowRef: WindowRef,
  ) {}

  orgTriageContinue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgTriageContinue),
        switchMap(() =>
          this.checkAuth().pipe(
            switchMap((isAuthenticated) => {
              const config = getConfigClientFromRTE();
              const baseHref = this.getBaseHref(this.windowRef.nativeWindow.location.href);
              const destinationUrl = `${baseHref}/inheritance/org-triage`;
              const prospectUrl = config.pretty_ecs_domain + config.pvr_endpoint;

              if (isAuthenticated) {
                return [Go({ path: ['/inheritance/org-triage'] })];
              }

              return this.httpClient
                .post(
                  'pvr-encrypt-svc',
                  {
                    destinationUrl,
                    flowType: 'COO',
                    fallout: `${config.pretty_ecs_domain}${config.cwp_prefix}/inheritance${config.ineligible_endpoint}`,
                  },
                  { responseType: 'text' },
                )
                .pipe(
                  map(() => External({ url: prospectUrl })),
                  catchError(() => [
                    Go({ path: ['/error'] }),
                    LogError({
                      payload: {
                        eventId: 'error-page-catch-pvr-encrypt-service',
                        message: 'PVR Encrypt Service Error',
                        code: LoggerCodes.NULL_FAILURE,
                      },
                    }),
                  ]),
                );
            }),
          ),
        ),
      ),
    { dispatch: true },
  );

  private checkAuth(): Observable<boolean> {
    return this.httpClient
      .post<{ poid: string; sPoid: string }>('secure/auth', {}, { withCredentials: true })
      .pipe(
        map(() => true),
        take(1),
        catchError(() => of(false)),
      );
  }

  private getBaseHref(currentHref: string): string {
    return new URL(currentHref).origin;
  }
}
